import {
  MsftPrivateOffer,
  Pricing,
} from 'pages/PrivateOffers/pages/Next/msft/api/types/MsftPrivateOffer';
import { msftPrivateOfferToMsftCreateOfferJSON } from 'pages/PrivateOffers/pages/Next/msft/api/transformers/msftPrivateOfferToMsftCreateOfferJSON';
import {
  CreatePreviewPricingJSON,
  MsftCreateOfferPreviewJSON,
} from '../types/MsftCreateOfferPreviewJSON';
import { CreatePricingJSON } from 'pages/PrivateOffers/pages/Next/msft/api/types/MsftCreateOfferJSON';
import { Optional } from 'utils/optional/optional';
import { formatIsoDateTimeAsIsoDate } from 'pages/PrivateOffers/pages/Next/generic/utils/date/dateUtils';
import {
  ScheduleDetailJSON,
  ScheduleDetailsJSON,
} from '../types/MsftPrivateOfferJSONSharedTypes';

const getPricing = (
  offerPricing: Pricing,
  createOfferPricingJSON: CreatePricingJSON,
): CreatePreviewPricingJSON => {
  const paymentSchedule = offerPricing?.paymentSchedule;

  const initialCharge = paymentSchedule?.initialCharge;
  const initial_charge = Optional.ofNullable(initialCharge)
    .map((ic) => ({
      price_per_payment_in_usd: ic.pricePerPaymentInUsd,
      note: ic.note,
    }))
    .orElse(null);

  const schedules = paymentSchedule.paymentSchedule || [];
  const schedule = schedules.map(
    (s): ScheduleDetailsJSON => ({
      charge_date: formatIsoDateTimeAsIsoDate(s.chargeDate),
      price_per_payment_in_usd: s.pricePerPaymentInUsd,
      note: s.note,
    }),
  );

  const payment_schedule: ScheduleDetailJSON = {
    initial_charge,
    payment_schedule: schedule,
  };

  return { ...createOfferPricingJSON, payment_schedule };
};

export const msftPrivateOfferToMsftCreateOfferPreviewJSON = (
  offer: Partial<MsftPrivateOffer>,
): MsftCreateOfferPreviewJSON => {
  const createOfferJSON = msftPrivateOfferToMsftCreateOfferJSON(offer);
  const pricing = getPricing(offer.pricing, createOfferJSON.pricing);

  return { ...createOfferJSON, pricing };
};
